import { generateClassName, getColorVariantFromBackground } from '@klv/shared/utils/functions';
import { Wrapper } from '@klv/utils/wrapper';
import BulletedListColumn from '@klv/molecules/bulleted-list-column';
import Buttons from '@klv/molecules/buttons';
import * as styles from './styles/bulletedLists.module.scss';
import type { IBulletedLists } from './types';

const BulletedLists = ({
  backgroundColor = 'light', 
  bodyCopy, 
  buttons, 
  bulletedListColumns, 
  headline, 
  showBullets = false, 
  customPadding = { customPaddingBottom: 'md', customPaddingTop: 'md' },
}: IBulletedLists) => {
  const colorVariant = getColorVariantFromBackground(backgroundColor);

  return (
    <Wrapper backgroundColor={backgroundColor} customPadding={customPadding}>
      <div className={generateClassName(['grid', styles.styledGrid])}>
        {(headline || bodyCopy) && (
          <div className={generateClassName(['grid', styles.introText])}>
            {headline && (
              <h2 className={generateClassName(['h3', styles.headline])}>{headline}</h2>
            )}
            {bodyCopy && (
              <p className={generateClassName(['p2', styles.bodyCopy])} dangerouslySetInnerHTML={{ __html: bodyCopy }} />              
            )}
          </div>
        )}

        {bulletedListColumns?.length && (
          <div className={generateClassName(['grid', styles.listsWrapper])}>
            {bulletedListColumns.map((list) => (
              <div
                key={JSON.stringify(list.bulletedListColumn)}
              >
                <BulletedListColumn
                  colorVariant={colorVariant}
                  headlineTag={headline ? 'h3' : 'h2'}
                  showBullets={showBullets}
                  {...list.bulletedListColumn}
                />
              </div>
            ))}
          </div>
        )}
        <Buttons className={styles.buttons} buttonColor={colorVariant} buttons={buttons} variants={['ghost']} />
      </div>
    </Wrapper>
  );
};

export default BulletedLists;
